export function getTourIdSelector(id: string) {
    return `[data-tour-id="${id}"]`;
}

export function getTestIdSelector(id: string) {
    return `[data-test-id="${id}"]`;
}